import React from 'react';
import { Truck, Snowflake, Wrench, Mail, ArrowRight, Check } from 'lucide-react';
import { ADMIN_CONTACTS, ENQUIRY_TEAMS, getEnquiryMailto } from '../lib/enquiries';

const ICONS = { 'fixed-logistic-services': Truck, 'fixed-chiller-freezer': Snowflake, 'fixed-borneo-reefer': Wrench };

export default function EnquiryContacts({ selectedTeam, onSelectTeam, disabled }) {
  return (
    <section className="pt-12 pb-6 md:pt-16" aria-labelledby="enquiry-teams-title">
      <div className="fx-container">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-widest font-semibold text-emerald-700">Three teams. One point of contact.</span>
          <h2 id="enquiry-teams-title" className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900">Let’s talk about your requirements.</h2>
          <p className="mt-4 text-slate-600">Choose a company to use our enquiry form, or email Bash directly. Both admin teams are copied to help coordinate your request.</p>
        </div>
        <div className="mt-8 grid md:grid-cols-3 gap-5">
          {ENQUIRY_TEAMS.map(team => {
            const Icon = ICONS[team.id];
            const selected = selectedTeam === team.id;
            return (
              <article key={team.id} className={`rounded-2xl border p-5 sm:p-6 flex flex-col min-w-0 ${selected ? 'border-emerald-600 bg-emerald-50/60 ring-1 ring-emerald-600' : 'border-slate-200 bg-white'}`}>
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-100 text-emerald-800"><Icon size={22} aria-hidden="true" /></span>
                  <span className="text-xs font-semibold uppercase tracking-wider text-emerald-700">{team.label}</span>
                </div>
                <h3 className="mt-5 text-lg font-bold leading-snug text-slate-900">{team.name}</h3>
                <p className="mt-2 mb-6 text-sm leading-relaxed text-slate-600">{team.description}</p>
                <a href={getEnquiryMailto(team.id)} className="mt-auto flex items-start gap-2 text-sm font-semibold text-emerald-800 hover:text-emerald-950 underline underline-offset-4">
                  <Mail size={16} className="mt-0.5 shrink-0" aria-hidden="true" /><span className="break-all">{team.email}</span>
                </a>
                <button type="button" disabled={disabled} aria-pressed={selected} onClick={() => onSelectTeam(team.id)}
                  data-testid={`enquire-team-${team.id}`} className="mt-6 flex min-h-11 items-center justify-center gap-2 rounded-lg bg-slate-900 px-3 py-3 text-sm font-semibold text-white hover:bg-emerald-800 disabled:opacity-50">
                  {selected ? <><Check size={16} aria-hidden="true" /> Selected for your enquiry</> : <>Use enquiry form <ArrowRight size={16} aria-hidden="true" /></>}
                </button>
              </article>
            );
          })}
        </div>
        <div className="mt-5 rounded-xl bg-slate-50 border border-slate-200 px-5 py-4 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
          <div className="lg:mr-auto"><h3 className="text-sm font-bold text-slate-800">Admin support</h3><p className="text-xs text-slate-500 mt-1">Copied on every enquiry</p></div>
          {ADMIN_CONTACTS.map(contact => (
            <div key={contact.email} className="min-w-0"><p className="text-xs text-slate-500">{contact.label}</p><span className="text-sm font-medium text-slate-700 break-all">{contact.email}</span></div>
          ))}
        </div>
      </div>
    </section>
  );
}
